import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import i18n from "@/plugins/i18n";

const vuetify = createVuetify({
  defaults: {
    global: {
      overlay: true,
      teleport: '#teleport-target',
    },
    locale: {
      locale: i18n.global.locale,
      t: (key) => i18n.global.t(key),
    },
  },
  components,
  directives,
  theme: {
    defaultTheme: 'cegat',
    themes: {
      cegat: {
        colors: {
          'primary-darken-1': '#142f61',
          primary: '#1d4289',
          secondary: '#f7f7f7',
          success: '#1d8955',
          error: '#c83214',

          body: '#000000',
          surface: '#f5f5f5',
          "on-surface": '#ccc',
          link: 'rgba(0,0,0,0.65)',
          "link-hover": '#000000',
          "link-black": 'rgba(0,0,0,0.65)',
          "footer-red": '#c83214',
          "header-bg": '#f4f5fa',
          "data-table-hover": 'rgba(255, 0, 0, 0.15)',

          red: '#c83214',
          "red-15": 'rgba(255, 0, 0, 0.26)',
          white: '#fff',
          grey: '#f7f7f7',
          'grey-stroke': '#e1e1e1',
          "grey-dark": '#e1e1e1',
          "grey-light": '#f7f7f7',
          "grey-common": 'rgba(0,0,0,0.65)',
          green: '#1d8955',
          blue: '#194691',
          "blue-50": '#8ea0c4',
          "blue-diagnostic": '#194691',
          "blue-diagnostic-5": 'rgba(25, 70, 145, 0.05)',
          "blue-hoverable": 'rgba(25, 70, 145, 0.85)',
          black: '#000',
          "black-15": '#e1e1e1',
          "black-30": '#b3b3b3',
          "black-50": '#7c7c7c',
          "black-75": '#3e3e3e',
        },
        variables: {
          'input-control-height': 'var(--v-input-control-height)',
          'theme-overlay-multiplier': 0.5,
          'theme-css-variables': 'true',
          'radio-label-opacity': '1',
          'main-opacity': '0.65',
          'hover-opacity': '0.3',
          'focus-opacity': '0.12',
          'activated-opacity': '0.12',
          'pressed-opacity': '0.12',

          /* Vuetify-native variables */
          'font-size-root': 'var(--v-body-font-size)',
          'line-height-root': 'var(--v-body-line-height)',
          'body-letter-spacing': 'var(--v-body-letter-spacing)',
          'link-color': 'var(--v-link-color)',
          'link-hover-color': 'var(--v-link-hover-color)',
          'link-text-decoration-thickness': 'var(--v-link-decoration-thickness)',
          'link-text-decoration-underline-offset': 'var(--v-link-decoration-offset)',
          'table-header-height': '48px',
          'table-row-height': '48px',
        },
      },
      zfh: {
        colors: {
        },
        variables: {
        }
      }
    },
  },
})

export default vuetify;
